export default "__VITE_ASSET__23d09c5d__"